export default {"src":"/_next/static/media/icon-pin-black.1b3b7951.svg","height":55,"width":40,"blurWidth":0,"blurHeight":0};